module.exports = __webpack_public_path__ + "static/experiment-building-small-65eaac2bc96ea9f90f121d6d0a327e1b.gif";